import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss'],
  standalone: false
})
export class SecondaryButtonComponent   {

  @Input() customClass: string = '';
  @Input() label: string = 'loading-button.loadMore';
  /** Ícono opcional (nombre de Ionicons) antes del texto. */
  @Input() icon?: string;
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() visible: boolean = true;
  @Input() topPadding: boolean = true;

  @Output() clicked = new EventEmitter<void>();

}
